import { enc } from 'crypto-js';
import sha256 from 'crypto-js/sha256';
import { AAuthenticationApi } from "eclipse-react-sdk/services/apis/aauthentication-api";
import HttpRequestConfiguration from "../../../http-request-configuration.js";
import { startAuthentication, startRegistration } from '@simplewebauthn/browser';
import { FromBinary } from '../../../utils.js';

const loginAPI = new AAuthenticationApi(HttpRequestConfiguration(" "));

function bufferToBase64URLString(buffer) {
    const bytes = new Uint8Array(buffer);
    let str = '';
    for (const charCode of bytes) {
        str += String.fromCharCode(charCode);
    }
    const base64String = btoa(str);
    return base64String.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}

const jsonToSHA256Base64 = (jsonString) => {
    const hash = sha256(jsonString);
    const base64EncodedHash = hash.toString(enc.Base64);
    return base64EncodedHash;
}

const loginWithWebAuthn = async ({ challenge, credentials, identity }) => {
    const loginBody = {
        "base64EncodedChallengeHash": jsonToSHA256Base64(challenge),
        "base64EncodedChallengeResponse": window.btoa(JSON.stringify(credentials)),
        identity,
    }
    return loginAPI.authenticationLoginPost(loginBody).then((authAPIResponse) => {
        return authAPIResponse;

    }).catch((error) => {
        throw error;
    });
}

const verifyLoginChallenge = async (challenge) => {
    const authenticatorSelection = {
        authenticatorAttachment: "platform",
        userVerification: "required"
    }
    if (challenge.publicKey) {
        return await startAuthentication({
            ...challenge.publicKey, authenticatorSelection
        }).then(credentials => {
            return { challenge: window.btoa(JSON.stringify(challenge)), credentials };
        });
    } else {
        return await startRegistration({
            ...challenge, authenticatorSelection
        }).then(credentials => {
            return { challenge: window.btoa(JSON.stringify(challenge)), credentials };
        });
    }
}

const getLoginChallenge = async (identity) => {
    return loginAPI.authenticationLoginChallengesGet(undefined, identity).then(async ({ data: { base64EncodedChallenge: challenge } }) => {
        return JSON.parse(FromBinary(window.atob(challenge)));
    }).catch((error) => {
        throw error;
    });
}

export {
    bufferToBase64URLString,
    loginWithWebAuthn,
    getLoginChallenge,
    jsonToSHA256Base64,
    verifyLoginChallenge
}